import ls from 'local-storage';

export default {

  getId (list) {
    return list.map((c) => {
      return c.id
    })
  },

  monthBegin () {
    const lsDate = ls.get('report.startDate');
    if (lsDate) {
      return new Date(lsDate);
    } else {
      const date = new Date();
      return new Date(date.getFullYear(), date.getMonth(), 1);
    }
  },

  monthEnd () {
    const lsDate = ls.get('report.endDate');
    if (lsDate) {
      return new Date(lsDate);
    } else {
      const date = new Date();
      return new Date(date.getFullYear(), date.getMonth() + 1, 0);
    }
  },
}